/**
 * Icons.jsx – Collection d'icônes SVG inline (style Heroicons / outline)
 * Usage : <Icon name="circuit" className="w-6 h-6 text-blue-600" />
 */

const paths = {
  circuit: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="3" ry="3" strokeWidth="1.5" />
      <circle cx="8"  cy="8"  r="1.5" fill="currentColor" />
      <circle cx="16" cy="8"  r="1.5" fill="currentColor" />
      <circle cx="8"  cy="16" r="1.5" fill="currentColor" />
      <circle cx="16" cy="16" r="1.5" fill="currentColor" />
      <line x1="8"  y1="9.5" x2="8"  y2="14.5" strokeWidth="1.5" />
      <line x1="16" y1="9.5" x2="16" y2="14.5" strokeWidth="1.5" />
      <line x1="9.5" y1="8"  x2="14.5" y2="8"  strokeWidth="1.5" />
      <line x1="9.5" y1="16" x2="14.5" y2="16" strokeWidth="1.5" />
    </>
  ),
  chip: (
    <>
      <rect x="7" y="7" width="10" height="10" rx="1" strokeWidth="1.5" />
      <line x1="9"  y1="7"  x2="9"  y2="3"  strokeWidth="1.5" strokeLinecap="round" />
      <line x1="12" y1="7"  x2="12" y2="3"  strokeWidth="1.5" strokeLinecap="round" />
      <line x1="15" y1="7"  x2="15" y2="3"  strokeWidth="1.5" strokeLinecap="round" />
      <line x1="9"  y1="17" x2="9"  y2="21" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="12" y1="17" x2="12" y2="21" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="15" y1="17" x2="15" y2="21" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="7"  y1="9"  x2="3"  y2="9"  strokeWidth="1.5" strokeLinecap="round" />
      <line x1="7"  y1="12" x2="3"  y2="12" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="7"  y1="15" x2="3"  y2="15" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="17" y1="9"  x2="21" y2="9"  strokeWidth="1.5" strokeLinecap="round" />
      <line x1="17" y1="12" x2="21" y2="12" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="17" y1="15" x2="21" y2="15" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  wifi: (
    <>
      <path d="M5 12.55a11 11 0 0 1 14 0"   strokeWidth="1.5" strokeLinecap="round" />
      <path d="M1.42 9A16 16 0 0 1 22.58 9" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="20" r="1" fill="currentColor" />
    </>
  ),
  code: (
    <>
      <polyline points="16 18 22 12 16 6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="8 6 2 12 8 18"   strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  bolt: (
    <>
      <path
        d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  beaker: (
    <>
      <path
        d="M9 3H15M9 3v6l-4 9a1 1 0 0 0 .895 1.447h10.21A1 1 0 0 0 17 18L13 9V3M9 3h6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.5" cy="15" r="0.8" fill="currentColor" />
      <circle cx="13"  cy="17" r="0.8" fill="currentColor" />
    </>
  ),
  cog: (
    <>
      <circle cx="12" cy="12" r="3" strokeWidth="1.5" />
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
        strokeWidth="1.5"
      />
    </>
  ),
  mail: (
    <>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeWidth="1.5" />
      <polyline points="22,6 12,13 2,6" strokeWidth="1.5" strokeLinejoin="round" />
    </>
  ),
  check: (
    <polyline points="20 6 9 17 4 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  'check-circle': (
    <>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="22 4 12 14.01 9 11.01" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  arrow: (
    <>
      <line x1="5" y1="12" x2="19" y2="12" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="12 5 19 12 12 19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  'arrow-left': (
    <>
      <line x1="19" y1="12" x2="5" y2="12" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="12 19 5 12 12 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  refresh: (
    <>
      <polyline points="1 4 1 10 7 10" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.51 15a9 9 0 1 0 .49-4.47" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
      <line x1="12" y1="8"  x2="12" y2="12" strokeWidth="2" strokeLinecap="round" />
      <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  euro: (
    <>
      <path d="M14 5C11.24 5 9 7.24 9 10s2.24 5 5 5" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="6" y1="9"  x2="15" y2="9"  strokeWidth="1.5" strokeLinecap="round" />
      <line x1="6" y1="13" x2="15" y2="13" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14 15c2.76 0 5-2.24 5-5s-2.24-5-5-5" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  phone: (
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.42 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  warning: (
    <>
      <path
        d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <line x1="12" y1="9"  x2="12" y2="13" strokeWidth="2" strokeLinecap="round" />
      <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
}

export default function Icon({ name, className = 'w-5 h-5' }) {
  const content = paths[name]
  if (!content) return null
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      className={className}
      aria-hidden="true"
    >
      {content}
    </svg>
  )
}
